import { createFileRoute } from '@tanstack/react-router';

import ScorecardHistoryPage from '../views/scorecard-history';

const METRICS = new Set([
  'overall_score',
  'average_rating',
  'review_count',
  'response_rate',
  'average_response_time',
  'platform_rating',
]);
const WINDOWS = new Set([30, 60, 90, 180]);
const HORIZONS = new Set([6, 12, 120]);

export type ScorecardHistorySearch = {
  source?: string;
  metric?: string;
  window?: number;
  horizon?: number;
  reconstructed?: boolean;
  snapshot?: string;
};

export const Route = createFileRoute('/h/$slug')({
  validateSearch: (input: Record<string, unknown>): ScorecardHistorySearch => {
    const source =
      typeof input.source === 'string' && /^[a-z0-9_-]+$/.test(input.source)
        ? input.source
        : undefined;
    const metric =
      typeof input.metric === 'string' && METRICS.has(input.metric) ? input.metric : undefined;
    const window = Number(input.window);
    const horizon = Number(input.horizon);
    const snapshot =
      typeof input.snapshot === 'string' &&
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
        input.snapshot,
      )
        ? input.snapshot
        : undefined;
    return {
      source,
      metric,
      window: WINDOWS.has(window) ? window : undefined,
      horizon: HORIZONS.has(horizon) ? horizon : undefined,
      reconstructed:
        input.reconstructed === false || input.reconstructed === 'false' ? false : undefined,
      snapshot,
    };
  },
  component: ScorecardHistoryPage,
});
